<template>
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.03318 3.36661C0.213175 5.18661 0.213175 8.13328 2.01984 9.95328C2.99984 7.68661 4.74651 5.79328 6.92651
      4.66661C5.07984 6.22661 3.78651 8.40661 3.33317 10.8799C5.06651 11.6999 7.19984 11.3999 8.63317 9.96661C10.6265
      7.97328 11.1865 2.53995 11.3065 1.04661C11.3198 0.839948 11.1532 0.673281 10.9532 0.693281C9.45984 0.813281
      4.02651 1.37328 2.03318 3.36661Z"
    />
  </svg>
</template>
<script>
  export default {
    name: 'Leaf'
  }
</script>
